import React, { ComponentProps } from 'react';
import { Modal } from 'antd';

type CustomProps = {
  shiftsCount: number;
  onConfirm: () => void;
};

type Props = CustomProps & ComponentProps<typeof Modal>;

export function ShiftsAddMultipleConfirmModal({
  onConfirm,
  shiftsCount,
  ...props
}: Props) {
  const isPlural = shiftsCount > 1;

  return (
    <>
      <Modal
        className="shifts-add-multiple-modal"
        title={`Confirm uploading ${shiftsCount} shift${isPlural ? 's' : ''}`}
        cancelText="Cancel"
        okText="Confirm"
        onOk={onConfirm}
        {...props}
      >
        Shifts created will automatically appear to available and qualified
        workers.
      </Modal>
      <style jsx>{`
        :global(.shifts-add-multiple-modal .ant-modal-footer) {
          text-align: right;
        }
      `}</style>
    </>
  );
}
